import { Injectable } from '@angular/core';
import { OverlayHandle, OverlayRole, OverlayService } from './overlay.service';

export interface MpAlertButton {
	text: string;
	role?: string;
	cssClass?: string | string[];
	handler?: (value?: any) => boolean | void | Promise<boolean | void>;
}

export interface MpAlertOptions {
	header?: string;
	subHeader?: string;
	message?: string;
	buttons?: (MpAlertButton | string)[];
	cssClass?: string | string[];
	backdropDismiss?: boolean;
	mode?: 'ios' | 'md';
}

/** Drop-in do AlertController do @ionic/angular. Monta o DOM do alerta (sem inputs — não usados no app). */
@Injectable({ providedIn: 'root' })
export class MpAlertController {
	constructor(private overlay: OverlayService) {}

	create(opts: MpAlertOptions): Promise<OverlayHandle> {
		const el = document.createElement('div');
		el.className = 'mp-alert';

		if (opts.header || opts.subHeader) {
			const head = document.createElement('div');
			head.className = 'mp-alert-head';
			if (opts.header) {
				const h = document.createElement('h2');
				h.className = 'mp-alert-title';
				h.textContent = opts.header;
				head.appendChild(h);
			}
			if (opts.subHeader) {
				const s = document.createElement('h3');
				s.className = 'mp-alert-subtitle';
				s.textContent = opts.subHeader;
				head.appendChild(s);
			}
			el.appendChild(head);
		}

		if (opts.message) {
			const msg = document.createElement('div');
			msg.className = 'mp-alert-message';
			msg.innerHTML = opts.message;
			el.appendChild(msg);
		}

		const group = document.createElement('div');
		group.className = 'mp-alert-button-group';
		el.appendChild(group);

		const handle = this.overlay.create({
			kind: 'alert',
			element: el,
			cssClass: opts.cssClass,
			backdropDismiss: opts.backdropDismiss,
		});

		const buttons = opts.buttons?.length ? opts.buttons : [{ text: 'OK' }];
		for (const raw of buttons) {
			const btn: MpAlertButton = typeof raw === 'string' ? { text: raw } : raw;
			const b = document.createElement('button');
			b.type = 'button';
			b.className = 'mp-alert-button';
			if (btn.cssClass) {
				(Array.isArray(btn.cssClass) ? btn.cssClass : [btn.cssClass]).forEach(c => b.classList.add(c));
			}
			b.textContent = btn.text;
			b.addEventListener('click', async () => {
				const result = btn.handler ? await btn.handler() : undefined;
				if (result === false) return; // handler cancela o fechamento
				handle.dismiss(undefined, btn.role);
			});
			group.appendChild(b);
		}

		return Promise.resolve(handle);
	}

	dismiss(data?: any, role?: OverlayRole): Promise<boolean> {
		return this.overlay.dismissTop(data, role, 'alert');
	}

	getTop(): Promise<OverlayHandle | undefined> {
		return Promise.resolve(this.overlay.getTop('alert'));
	}
}
